import styled from 'styled-components';
import ArrowLeftDetailIconSVG from '../../assets/hotels/arrow-left.svg';

const ArrowLeftDetailIcon = styled(
  ArrowLeftDetailIconSVG as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.color};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default ArrowLeftDetailIcon;
